import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DataFlowV2Service from "src/modules/data-protection/apis/DataFlowV2Service";
import { invalidateSoftwareDataFlowsV2 } from "./useSoftwareDataFlowsV2";

const useDeleteDataFlow = ({ softwareId, t, onSuccess } = {}) => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (id) => {
            const service = DataFlowV2Service.getInstance();

            return await service.deleteDataFlow(id);
        },
        onSuccess: () => {
            toast(t("Data flow deleted successfully."), {
                type: "success",
            });

            invalidateSoftwareDataFlowsV2(queryClient);

            if (typeof onSuccess === "function") {
                onSuccess();
            }
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t("Failed to delete data flow."), {
                type: "error",
            });
        },
    });

    const deleteFlow = (id) => {
        if (!id) {
            return;
        }

        mutation.mutate(id);
    };

    return {
        deleteFlow,
        isDeleting: mutation.isLoading,
    };
};

export default useDeleteDataFlow;
